module.exports = __webpack_public_path__ + "img/close.2aaeda90.svg";